import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private _loading: boolean = true;
  loadingStatus: Subject<boolean> = new Subject<boolean>();

  constructor() { }

  get loading(): boolean {
    return this._loading;
  }

  set loading(value) {
    this._loading = value;
    this.loadingStatus.next(value);
  }

  public show() {
    this.loading = true;
  }

  public hide() {
    this.loading = false;
  }
}
